import { formatError } from '@faro/app-context';
import { FaroAlert, FaroAlertProps } from '@faro/design-system';
import { ReactNode, useEffect } from 'react';

export interface ErrorMessageProps extends Omit<FaroAlertProps, 'type'> {
    message: string;
    error: unknown;
}

function ErrorMessage(props: ErrorMessageProps): ReactNode {
    const { message, error, className = '', ref, ...rest } = props;

    useEffect(() => {
        // Captures error for app-insights
        console.error(message, error);
    }, [error]);

    const formattedError = formatError(error);

    return (
        <FaroAlert
            {...rest}
            ref={ref}
            className={`
                ${className}
            `}
            type="error"
        >
            <FaroAlert.Header>{message}</FaroAlert.Header>
            {formattedError && <FaroAlert.Body>{formattedError}</FaroAlert.Body>}
        </FaroAlert>
    );
}

export default ErrorMessage;
